<button
  type="button"
  [class]="computedRootClasses"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel || label"
  [attr.aria-pressed]="selected"
  (click)="toggle()"
>
  <span class="munily-selectable-option-card__icon" aria-hidden="true">
    <mat-icon [class]="iconSet">{{ icon }}</mat-icon>
  </span>

  <span class="munily-selectable-option-card__content">
    <span class="munily-selectable-option-card__label b2_500">{{ label }}</span>
    <span class="munily-selectable-option-card__description c1_400">
      {{ description }}
    </span>
  </span>

  <span class="munily-selectable-option-card__selection" aria-hidden="true">
    <mat-icon *ngIf="selected" class="material-symbols-rounded">check</mat-icon>
  </span>
</button>
